/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import LocaleMsg from 'loracoms/LocaleMsg';

export function notEmptyValidator() {
  return (v) => {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.cannotbeempty" />,
      };
    }
    return {
      valid: true,
    };
  };
}

export function hexValidator(len) {
  return (v) => {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.cannotbeempty" />,
      };
    }
    if (new RegExp(`^[0-9A-Fa-f]{${len}}$`).test(v.replace(/[:-]/g, ''))) {
      return {
        valid: true,
      };
    }
    return {
      valid: false,
      errmsg: <LocaleMsg id="lora.error.invalidformat" />,
    };
  };
}

export function hexNumValidator(min, max, prefix = '0x') {
  return (v) => {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.cannotbeempty" />,
      };
    }
    if (new RegExp(`^${prefix}[0-9A-Fa-f]+$`).test(v.replace(/[:-]/g, ''))) {
      const numv = parseInt(v, 16);
      if (numv < min) {
        return {
          valid: false,
          errmsg: <LocaleMsg id="lora.error.integer.toolow" />,
        };
      }
      if (numv > max) {
        return {
          valid: false,
          errmsg: <LocaleMsg id="lora.error.integer.toolarge" />,
        };
      }
      return {
        valid: true,
      };
    }
    return {
      valid: false,
      errmsg: <LocaleMsg id="lora.error.invalidformat" />,
    };
  };
}

export function binNumValidator(min, max, prefix = '0b') {
  return (v) => {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.cannotbeempty" />,
      };
    }
    if (new RegExp(`^${prefix}[01]+$`).test(v.replace(/[:-]/g, ''))) {
      const numv = parseInt(v, 2);
      if (numv < min) {
        return {
          valid: false,
          errmsg: <LocaleMsg id="lora.error.integer.toolow" />,
        };
      }
      if (numv > max) {
        return {
          valid: false,
          errmsg: <LocaleMsg id="lora.error.integer.toolarge" />,
        };
      }
      return {
        valid: true,
      };
    }
    return {
      valid: false,
      errmsg: <LocaleMsg id="lora.error.invalidformat" />,
    };
  };
}

export function intValidator(min, max) {
  return (v) => {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.cannotbeempty" />,
      };
    }
    if (!/^-?\d+$/.test(v.trim())) {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.integer.nan" />,
      };
    }
    const numv = Number(v);
    if (numv < min) {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.integer.toolow" />,
      };
    }
    if (numv > max) {
      return {
        valid: false,
        errmsg: <LocaleMsg id="lora.error.integer.toolarge" />,
      };
    }
    return { valid: true };
  };
}

export function orValidator(validators = []) {
  if (validators.length === 0) {
    return { valid: true };
  }

  return (v) => {
    const results = validators.map(validator => validator(v));
    if (_.some(results, 'valid')) {
      return { valid: true };
    }
    return results[0];
  };
}




// WEBPACK FOOTER //
// ./src/utils/Validators.js